import React, {useEffect} from 'react'
import {ModeleMesActions, modeleMesActionsInitValues} from '../../../components/Models'
import {useNavigate} from 'react-router-dom'
import {createMesActions} from '../../../components/requests'
import {MesActionsForm} from './components/MesActionsForm'
import {useLocation} from 'react-router'

interface LocationState {
  view?: 'List' | 'Kanban' | 'Table' | null | undefined
  filters?: any
}

const MesActionsAddPage = (props) => {
  const navigate = useNavigate()
  const location = useLocation()
  const ls = location.state as LocationState | null

  useEffect(() => {
    if (props?.handleFilterArian) {
      props.handleFilterArian(ls?.view, ls?.filters)
    }
  }, [])

  const submitForm = async (fieldsToUpdate: Partial<ModeleMesActions>, callback): Promise<void> => {
    const updatedData = Object.assign({...modeleMesActionsInitValues}, fieldsToUpdate)

    try {
      const actionRequest = await createMesActions(updatedData)
      if (actionRequest?.status === 200) {
        if (actionRequest?.data?.id !== undefined && actionRequest?.data?.id !== null) {
          navigate(`/mes-actions/liste`, {state: {view : ls?.view, filters: ls?.filters}})
        }
      }
    } catch (ex) {
      console.error(ex)
    } finally {
      callback()
    }
  }

  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div className='card-header border-0'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>Créer une action</h3>
          </div>
        </div>

        <div>
          <MesActionsForm data={modeleMesActionsInitValues} submitForm={submitForm} view={ls?.view} filter={ls?.filters} />
        </div>
      </div>
    </>
  )
}

export default MesActionsAddPage
